import { useCallback, useMemo } from 'react';
import { useTranslation } from '~/Locale';
import { getSelectableCountries } from '~/helpers/countries';
import { useApprovedCountries } from './useApprovedCountries';

export const useSelectableCountries = (isDisabled = false) => {
  const { t } = useTranslation();
  const { approvedCountryCodes, isLoading, hasError, retry } =
    useApprovedCountries();

  const options = useMemo(
    () => getSelectableCountries(t, approvedCountryCodes),
    [t, approvedCountryCodes]
  );
  const loadErrorMessage = t(
    'Could not load the list of countries. Open the list to try again.'
  );
  const getLoadErrorMessage = useCallback(
    () => loadErrorMessage,
    [loadErrorMessage]
  );
  const getLoadingMessage = useCallback(() => t('Loading...'), [t]);
  const getNoOptionsMessage = useCallback(() => t('No options'), [t]);
  const showLoadError = hasError && !isDisabled;

  return {
    options,
    isLoading: isLoading && !isDisabled,
    loadingMessage: getLoadingMessage,
    noOptionsMessage: showLoadError ? getLoadErrorMessage : getNoOptionsMessage,
    ...(showLoadError && { helperText: loadErrorMessage, onMenuOpen: retry })
  };
};
